<div class="m-page-loader m-page-loader--base m-page-loader--non-block" style="margin-left: -80px; margin-top: -20px;">
  <div class="m-blockui">
    <span>
      Yükleniyor...
    </span>
    <span>
      <div class="m-loader m-loader--brand"></div>
    </span>
  </div>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0.05)" size="large" color="#4aa2ff" type="ball-spin-clockwise" [fullScreen]="true"></ngx-spinner>
<router-outlet></router-outlet>
<app-quick-sidebar></app-quick-sidebar>
<app-scroll-top></app-scroll-top>
